import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "../initialState.js";
import {
  getCashRegistersReport,
  getClientsReport,
  getEmployeesBalanceReport,
  getExpansesReport,
  getMechanicSalaryReport,
  getNotSoldReport,
  getProfitOthersIncomeReport,
  getProfitPartsReport,
  getProfitStatistics,
  getProfitWorksReport,
  getBalanceStatistics,
  getBalanceSalesReport,
  getStaffSalaryReport,
  getSuppliersReport,
  getSuppliersBalanceReport,
  getSuppliersStatistics,
  getTaxesReport,
  getWarehousesDisposals,
  getWarehousesReport,
  getWarehousesReturns,
  getWarehousesStatistics,
  getWarehousesBalanceReport,
  getWorkAndReadyList,
} from "./operations.js";

const handlePending = state => {
  state.isLoading = true;
  state.error = null;
};

const handleRejected = (state, action) => {
  state.isLoading = false;
  state.error = action.payload;
};

const ReportsSlice = createSlice({
  name: "accounting",
  initialState: initialState.reports,
  reducers: {
    clearSuppliersOrders: state => {
      state.suppliers = [];
      state.error = null;
    },
  },
  extraReducers: builder =>
    builder
      // ! BALANCE

      // Get Reports statistics +
      .addCase(getBalanceStatistics.pending, state => {
        state.isLoadingStats = true;
        state.error = null;
      })
      .addCase(getBalanceStatistics.fulfilled, (state, action) => {
        state.isLoadingStats = false;
        state.balanceStats = action.payload;
      })
      .addCase(getBalanceStatistics.rejected, (state, action) => {
        state.isLoadingStats = false;
        state.error = action.payload;
      })

      // Get cars in work & ready list +
      .addCase(getWorkAndReadyList.pending, handlePending)
      .addCase(getWorkAndReadyList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.workAndReadyList = action.payload;
      })
      .addCase(getWorkAndReadyList.rejected, handleRejected)

      // Get Suppliers Report +
      .addCase(getSuppliersBalanceReport.pending, handlePending)
      .addCase(getSuppliersBalanceReport.fulfilled, (state, action) => {
        state.isLoading = false;
        state.suppliers = action.payload.suppliers;
      })
      .addCase(getSuppliersBalanceReport.rejected, handleRejected)

      .addCase(getEmployeesBalanceReport.pending, handlePending)
      .addCase(getEmployeesBalanceReport.fulfilled, (state, action) => {
        state.isLoading = false;
        state.employees = action.payload.employees;
      })
      .addCase(getEmployeesBalanceReport.rejected, handleRejected)

      .addCase(getWarehousesBalanceReport.pending, handlePending)
      .addCase(getWarehousesBalanceReport.fulfilled, (state, action) => {
        state.isLoading = false;
        state.warehousesStock = action.payload.warehouses;
      })
      .addCase(getWarehousesBalanceReport.rejected, handleRejected)

      // Get CashRegisters Report +
      .addCase(getCashRegistersReport.pending, handlePending)
      .addCase(getCashRegistersReport.fulfilled, (state, action) => {
        state.isLoading = false;
        state.cashRegistersReport = action.payload.cash_registers;
      })
      .addCase(getCashRegistersReport.rejected, handleRejected)

      .addCase(getBalanceSalesReport.pending, handlePending)
      .addCase(getBalanceSalesReport.fulfilled, (state, action) => {
        state.isLoading = false;
        state.balanceSalesReport = action.payload;
      })
      .addCase(getBalanceSalesReport.rejected, handleRejected)

      // ! SUPPLIERS STATISTICS
      // suppliers stats
      .addCase(getSuppliersStatistics.pending, state => {
        state.isSuppliersStatsLoading = true;
        state.error = null;
      })
      .addCase(getSuppliersStatistics.fulfilled, (state, action) => {
        state.isSuppliersStatsLoading = false;
        state.suppliersStats = action.payload;
      })
      .addCase(getSuppliersStatistics.rejected, (state, action) => {
        state.isSuppliersStatsLoading = false;
        state.error = action.payload;
      })

      // NotSold report
      .addCase(getNotSoldReport.pending, state => {
        state.isNotSoldReportLoading = true;
        state.error = null;
      })
      .addCase(getNotSoldReport.fulfilled, (state, action) => {
        state.isNotSoldReportLoading = false;
        state.notSoldReport = action.payload;
      })
      .addCase(getNotSoldReport.rejected, (state, action) => {
        state.isNotSoldReportLoading = false;
        state.error = action.payload;
      })

      // SuppliersReport
      .addCase(getSuppliersReport.pending, state => {
        state.isSuppliersReportLoading = true;
        state.error = null;
      })
      .addCase(getSuppliersReport.fulfilled, (state, action) => {
        state.isSuppliersReportLoading = false;
        state.suppliersReport = action.payload;
      })
      .addCase(getSuppliersReport.rejected, (state, action) => {
        state.isSuppliersReportLoading = false;
        state.error = action.payload;
      })

      // ! CLIENTS REPORTS
      .addCase(getClientsReport.pending, state => {
        state.isClientsReportLoading = true;
        state.error = null;
      })
      .addCase(getClientsReport.fulfilled, (state, action) => {
        state.isClientsReportLoading = false;
        state.clientsStats = action.payload.statistics;
        state.clientsList = action.payload.clients;
      })
      .addCase(getClientsReport.rejected, (state, action) => {
        state.isClientsReportLoading = false;
        state.error = action.payload;
      })

      // ! PROFIT REPORTS
      // Profit Statistics
      .addCase(getProfitStatistics.pending, state => {
        state.profitStatsLoading = true;
        state.error = null;
      })
      .addCase(getProfitStatistics.fulfilled, (state, action) => {
        state.profitStatsLoading = false;
        state.profitStats = action.payload;
      })
      .addCase(getProfitStatistics.rejected, (state, action) => {
        state.profitStatsLoading = false;
        state.error = action.payload;
      })

      // Profit Parts Report
      .addCase(getProfitPartsReport.pending, state => {
        state.profitPartsLoading = true;
        state.error = null;
      })
      .addCase(getProfitPartsReport.fulfilled, (state, action) => {
        state.profitPartsLoading = false;
        state.profitPartsReport = action.payload;
      })
      .addCase(getProfitPartsReport.rejected, (state, action) => {
        state.profitPartsLoading = false;
        state.error = action.payload;
      })

      // Profit Works Report
      .addCase(getProfitWorksReport.pending, state => {
        state.profitWorksLoading = true;
        state.error = null;
      })
      .addCase(getProfitWorksReport.fulfilled, (state, action) => {
        state.profitWorksLoading = false;
        state.profitWorksReport = action.payload;
      })
      .addCase(getProfitWorksReport.rejected, (state, action) => {
        state.profitWorksLoading = false;
        state.error = action.payload;
      })

      // Profit Others Income Report
      .addCase(getProfitOthersIncomeReport.pending, state => {
        state.profitOthersIncomeLoading = true;
        state.error = null;
      })
      .addCase(getProfitOthersIncomeReport.fulfilled, (state, action) => {
        state.profitOthersIncomeLoading = false;
        state.profitOthersIncomeReport = action.payload;
      })
      .addCase(getProfitOthersIncomeReport.rejected, (state, action) => {
        state.profitOthersIncomeLoading = false;
        state.error = action.payload;
      })

      // Mechanic Salary Report
      .addCase(getMechanicSalaryReport.pending, state => {
        state.mechanicSalaryReportLoading = true;
        state.error = null;
      })
      .addCase(getMechanicSalaryReport.fulfilled, (state, action) => {
        state.mechanicSalaryReportLoading = false;
        state.mechanicSalaryReport = action.payload;
      })
      .addCase(getMechanicSalaryReport.rejected, (state, action) => {
        state.mechanicSalaryReportLoading = false;
        state.error = action.payload;
      })

      // Staff Salary Report
      .addCase(getStaffSalaryReport.pending, state => {
        state.staffSalaryReportLoading = true;
        state.error = null;
      })
      .addCase(getStaffSalaryReport.fulfilled, (state, action) => {
        state.staffSalaryReportLoading = false;
        state.staffSalaryReport = action.payload;
      })
      .addCase(getStaffSalaryReport.rejected, (state, action) => {
        state.staffSalaryReportLoading = false;
        state.error = action.payload;
      })

      // Get Taxes Report
      .addCase(getTaxesReport.pending, state => {
        state.taxesReportLoading = true;
        state.error = null;
      })
      .addCase(getTaxesReport.fulfilled, (state, action) => {
        state.taxesReportLoading = false;
        state.taxesReport = action.payload;
      })
      .addCase(getTaxesReport.rejected, (state, action) => {
        state.taxesReportLoading = false;
        state.error = action.payload;
      })

      // Get Expanses Report
      .addCase(getExpansesReport.pending, state => {
        state.expansesReportLoading = true;
        state.error = null;
      })
      .addCase(getExpansesReport.fulfilled, (state, action) => {
        state.expansesReportLoading = false;
        state.expansesReport = action.payload;
      })
      .addCase(getExpansesReport.rejected, (state, action) => {
        state.expansesReportLoading = false;
        state.error = action.payload;
      })

      // ! WAREHOUSES REPORTS
      // Warehouses Stats
      .addCase(getWarehousesStatistics.pending, state => {
        state.warehousesStatsLoading = true;
        state.error = null;
      })
      .addCase(getWarehousesStatistics.fulfilled, (state, action) => {
        state.warehousesStatsLoading = false;
        state.warehousesStats = action.payload;
      })
      .addCase(getWarehousesStatistics.rejected, (state, action) => {
        state.warehousesStatsLoading = false;
        state.error = action.payload;
      })

      // Warehouses Report
      .addCase(getWarehousesReport.pending, state => {
        state.warehousesReportLoading = true;
        state.error = null;
      })
      .addCase(getWarehousesReport.fulfilled, (state, action) => {
        state.warehousesReportLoading = false;
        state.warehousesStats = {
          ...state.warehousesStats,
          total_initial_quantity: action.payload.total_initial_quantity,
          total_initial_amount: action.payload.total_initial_amount,
        };
        state.warehousesReport = action.payload.data;
      })
      .addCase(getWarehousesReport.rejected, (state, action) => {
        state.warehousesReportLoading = false;
        state.error = action.payload;
      })

      // Warehouses Returns
      .addCase(getWarehousesReturns.pending, state => {
        state.warehousesReturnsLoading = true;
        state.error = null;
      })
      .addCase(getWarehousesReturns.fulfilled, (state, action) => {
        state.warehousesReturnsLoading = false;
        state.warehousesReturns = action.payload.data;
      })
      .addCase(getWarehousesReturns.rejected, (state, action) => {
        state.warehousesReturnsLoading = false;
        state.error = action.payload;
      })

      // Warehouses Disposals
      .addCase(getWarehousesDisposals.pending, state => {
        state.warehousesDisposalsLoading = true;
        state.error = null;
      })
      .addCase(getWarehousesDisposals.fulfilled, (state, action) => {
        state.warehousesDisposalsLoading = false;
        state.warehousesDisposals = action.payload.data;
      })
      .addCase(getWarehousesDisposals.rejected, (state, action) => {
        state.warehousesDisposalsLoading = false;
        state.error = action.payload;
      }),
});

export const { clearSuppliersOrders } = ReportsSlice.actions;

export default ReportsSlice.reducer;
